<template>
  <div class="home">
    <div class="hero">
      <div class="hero-icon">
        <svg viewBox="0 0 80 80" width="80" height="80" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="heroMoonGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:1" />
              <stop offset="100%" style="stop-color:#f59e0b;stop-opacity:1" />
            </linearGradient>
            <linearGradient id="heroGlowGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#3b82f6;stop-opacity:0.2" />
              <stop offset="100%" style="stop-color:#8b5cf6;stop-opacity:0.05" />
            </linearGradient>
          </defs>
          <!-- 光晕背景 -->
          <circle cx="40" cy="40" r="38" fill="url(#heroGlowGradient)" />
          <!-- 月亮主体 -->
          <path d="M40 8 C24 8 12 24 12 40 C12 56 24 72 40 72 C28 64 28 16 40 8" fill="url(#heroMoonGradient)" />
          <!-- 上升箭头 -->
          <path d="M56 36 L64 24 L72 36" stroke="#3b82f6" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M64 28 L64 52" stroke="#3b82f6" stroke-width="4" fill="none" stroke-linecap="round" />
          <!-- 星星 -->
          <circle cx="52" cy="16" r="3" fill="#fbbf24" />
          <circle cx="68" cy="56" r="2" fill="#3b82f6" />
          <circle cx="20" cy="20" r="1.5" fill="#fbbf24" opacity="0.6" />
        </svg>
      </div>
      <h1>{{ $t('site.name') }}</h1>
      <p>{{ $t('site.slogan') }}</p>
    </div>

    <div class="tools-section">
      <h2>{{ $t('home.sections.textTools') }}</h2>
      <p class="section-desc">{{ $t('home.sections.textToolsDesc') }}</p>
      <div class="tools-grid">
        <router-link to="/wordcount" class="tool-card">
          <div class="tool-icon">📝</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.wordcount.title') }}</h3>
            <p>{{ $t('home.tools.wordcount.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/markdown" class="tool-card">
          <div class="tool-icon">📄</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.markdown.title') }}</h3>
            <p>{{ $t('home.tools.markdown.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/traditional" class="tool-card">
          <div class="tool-icon">繁</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.traditional.title') }}</h3>
            <p>{{ $t('home.tools.traditional.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/uppercase" class="tool-card">
          <div class="tool-icon">壹</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.uppercase.title') }}</h3>
            <p>{{ $t('home.tools.uppercase.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/text-dedup" class="tool-card">
          <div class="tool-icon">🔄</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.textDedup.title') }}</h3>
            <p>{{ $t('home.tools.textDedup.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/text-replace" class="tool-card">
          <div class="tool-icon">🔍</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.textReplace.title') }}</h3>
            <p>{{ $t('home.tools.textReplace.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/text-sort" class="tool-card">
          <div class="tool-icon">↕️</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.textSort.title') }}</h3>
            <p>{{ $t('home.tools.textSort.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/text-number" class="tool-card">
          <div class="tool-icon">🔢</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.textNumber.title') }}</h3>
            <p>{{ $t('home.tools.textNumber.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/text-to-html" class="tool-card">
          <div class="tool-icon">🌐</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.text2html.title') }}</h3>
            <p>{{ $t('home.tools.text2html.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/word-frequency" class="tool-card">
          <div class="tool-icon">📊</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.wordFreq.title') }}</h3>
            <p>{{ $t('home.tools.wordFreq.desc') }}</p>
          </div>
        </router-link>
      </div>
    </div>

    <div class="tools-section">
      <h2>{{ $t('home.sections.devTools') }}</h2>
      <p class="section-desc">{{ $t('home.sections.devToolsDesc') }}</p>
      <div class="tools-grid">
        <router-link to="/json" class="tool-card">
          <div class="tool-icon">📋</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.json.title') }}</h3>
            <p>{{ $t('home.tools.json.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/timestamp" class="tool-card">
          <div class="tool-icon">⏰</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.timestamp.title') }}</h3>
            <p>{{ $t('home.tools.timestamp.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/calculator" class="tool-card">
          <div class="tool-icon">🔢</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.calculator.title') }}</h3>
            <p>{{ $t('home.tools.calculator.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/naming-converter" class="tool-card">
          <div class="tool-icon">🔤</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.namingConverter.title') }}</h3>
            <p>{{ $t('home.tools.namingConverter.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/regex" class="tool-card">
          <div class="tool-icon">🔍</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.regexTester.title') }}</h3>
            <p>{{ $t('home.tools.regexTester.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/color-converter" class="tool-card">
          <div class="tool-icon">🎨</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.colorConverter.title') }}</h3>
            <p>{{ $t('home.tools.colorConverter.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/code-formatter" class="tool-card">
          <div class="tool-icon">💻</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.codeFormatter.title') }}</h3>
            <p>{{ $t('home.tools.codeFormatter.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/crontab" class="tool-card">
          <div class="tool-icon">⏱️</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.crontab.title') }}</h3>
            <p>{{ $t('home.tools.crontab.desc') }}</p>
          </div>
        </router-link>
      </div>
    </div>

    <div class="tools-section">
      <h2>{{ $t('home.sections.codecTools') }}</h2>
      <p class="section-desc">{{ $t('home.sections.codecToolsDesc') }}</p>
      <div class="tools-grid">
        <router-link to="/base64" class="tool-card">
          <div class="tool-icon">🔐</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.base64.title') }}</h3>
            <p>{{ $t('home.tools.base64.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/url-codec" class="tool-card">
          <div class="tool-icon">🔗</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.urlCodec.title') }}</h3>
            <p>{{ $t('home.tools.urlCodec.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/hash" class="tool-card">
          <div class="tool-icon">#️⃣</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.hashTool.title') }}</h3>
            <p>{{ $t('home.tools.hashTool.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/unicode" class="tool-card">
          <div class="tool-icon">🌐</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.unicodeConverter.title') }}</h3>
            <p>{{ $t('home.tools.unicodeConverter.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/morse" class="tool-card">
          <div class="tool-icon">📡</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.morseCode.title') }}</h3>
            <p>{{ $t('home.tools.morseCode.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/password-gen" class="tool-card">
          <div class="tool-icon">🔑</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.passwordGen.title') }}</h3>
            <p>{{ $t('home.tools.passwordGen.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/uuid" class="tool-card">
          <div class="tool-icon">🆔</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.uuidGen.title') }}</h3>
            <p>{{ $t('home.tools.uuidGen.desc') }}</p>
          </div>
        </router-link>
      </div>
    </div>

    <div class="tools-section">
      <h2>{{ $t('home.sections.imageTools') }}</h2>
      <p class="section-desc">{{ $t('home.sections.imageToolsDesc') }}</p>
      <div class="tools-grid">
        <router-link to="/image" class="tool-card">
          <div class="tool-icon">🖼️</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.image.title') }}</h3>
            <p>{{ $t('home.tools.image.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/qr-generator" class="tool-card">
          <div class="tool-icon">📱</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.qrGenerator.title') }}</h3>
            <p>{{ $t('home.tools.qrGenerator.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/qr-scanner" class="tool-card">
          <div class="tool-icon">📷</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.qrScanner.title') }}</h3>
            <p>{{ $t('home.tools.qrScanner.desc') }}</p>
          </div>
        </router-link>
      </div>
    </div>

    <div class="tools-section">
      <h2>{{ $t('home.sections.lifeTools') }}</h2>
      <p class="section-desc">{{ $t('home.sections.lifeToolsDesc') }}</p>
      <div class="tools-grid">
        <router-link to="/mortgage" class="tool-card">
          <div class="tool-icon">🏠</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.mortgage.title') }}</h3>
            <p>{{ $t('home.tools.mortgage.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/tax" class="tool-card">
          <div class="tool-icon">💰</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.tax.title') }}</h3>
            <p>{{ $t('home.tools.tax.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/bmi" class="tool-card">
          <div class="tool-icon">⚖️</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.bmi.title') }}</h3>
            <p>{{ $t('home.tools.bmi.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/exchange" class="tool-card">
          <div class="tool-icon">💱</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.exchange.title') }}</h3>
            <p>{{ $t('home.tools.exchange.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/tax-rate" class="tool-card">
          <div class="tool-icon">🧾</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.taxRate.title') }}</h3>
            <p>{{ $t('home.tools.taxRate.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/list-sum" class="tool-card">
          <div class="tool-icon">➕</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.listSum.title') }}</h3>
            <p>{{ $t('home.tools.listSum.desc') }}</p>
          </div>
        </router-link>

        <router-link to="/loan-calc" class="tool-card">
          <div class="tool-icon">🏦</div>
          <div class="tool-info">
            <h3>{{ $t('home.tools.loanCalc.title') }}</h3>
            <p>{{ $t('home.tools.loanCalc.desc') }}</p>
          </div>
        </router-link>
      </div>
    </div>

    <!-- 使用说明 -->
    <div class="usage-section">
      <h2>{{ $t('home.usage.title') }}</h2>
      <div class="usage-steps">
        <div class="usage-step">
          <div class="step-number">1</div>
          <div class="step-content">
            <h3>{{ $t('home.usage.step1.title') }}</h3>
            <p>{{ $t('home.usage.step1.desc') }}</p>
          </div>
        </div>
        <div class="usage-step">
          <div class="step-number">2</div>
          <div class="step-content">
            <h3>{{ $t('home.usage.step2.title') }}</h3>
            <p>{{ $t('home.usage.step2.desc') }}</p>
          </div>
        </div>
        <div class="usage-step">
          <div class="step-number">3</div>
          <div class="step-content">
            <h3>{{ $t('home.usage.step3.title') }}</h3>
            <p>{{ $t('home.usage.step3.desc') }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 常见问题 -->
    <div class="faq-section">
      <h2>{{ $t('home.faq.title') }}</h2>
      <div class="faq-list">
        <div class="faq-item">
          <h3>{{ $t('home.faq.q1.question') }}</h3>
          <p>{{ $t('home.faq.q1.answer') }}</p>
        </div>
        <div class="faq-item">
          <h3>{{ $t('home.faq.q2.question') }}</h3>
          <p>{{ $t('home.faq.q2.answer') }}</p>
        </div>
        <div class="faq-item">
          <h3>{{ $t('home.faq.q3.question') }}</h3>
          <p>{{ $t('home.faq.q3.answer') }}</p>
        </div>
        <div class="faq-item">
          <h3>{{ $t('home.faq.q4.question') }}</h3>
          <p>{{ $t('home.faq.q4.answer') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage'
}
</script>

<style scoped>
.home {
  max-width: 1200px;
  margin: 0 auto;
}

.hero {
  text-align: center;
  margin-bottom: 48px;
}

.hero-icon {
  margin-bottom: 20px;
  animation: float 3s ease-in-out infinite;
}

.hero-icon svg {
  filter: drop-shadow(0 4px 12px rgba(59, 130, 246, 0.3));
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.hero h1 {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 16px;
  background: linear-gradient(135deg, var(--accent-color), #8b5cf6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero p {
  font-size: 18px;
  color: var(--text-secondary);
}

.tools-section {
  margin-bottom: 48px;
}

.tools-section h2 {
  font-size: 24px;
  margin-bottom: 24px;
  padding-left: 12px;
  border-left: 4px solid var(--accent-color);
  color: var(--text-primary);
}

.tools-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.tool-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  text-decoration: none;
  color: inherit;
  transition: all 0.3s;
  box-shadow: var(--shadow-sm);
}

.tool-card:hover {
  transform: translateY(-4px);
  border-color: var(--accent-color);
  box-shadow: var(--shadow-lg);
}

.tool-icon {
  font-size: 40px;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--accent-light);
  border-radius: 12px;
}

.tool-info h3 {
  font-size: 18px;
  margin-bottom: 6px;
  color: var(--text-primary);
}

.tool-info p {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.6;
}

/* 介绍区域 */
.intro-section {
  margin-bottom: 48px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 32px;
  box-shadow: var(--shadow-sm);
}

.intro-content h2 {
  font-size: 24px;
  margin-bottom: 20px;
  color: var(--text-primary);
}

.intro-content p {
  font-size: 15px;
  color: var(--text-secondary);
  line-height: 1.8;
  margin-bottom: 16px;
}

.intro-features {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 24px;
}

.intro-feature {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: var(--accent-light);
  border-radius: 20px;
}

.intro-feature .feature-icon {
  font-size: 18px;
}

.intro-feature .feature-text {
  font-size: 14px;
  color: var(--text-primary);
  font-weight: 500;
}

/* 分类描述 */
.section-desc {
  font-size: 15px;
  color: var(--text-secondary);
  margin-bottom: 20px;
  line-height: 1.6;
}

/* 使用说明 */
.usage-section {
  margin-bottom: 48px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 32px;
  box-shadow: var(--shadow-sm);
}

.usage-section h2 {
  font-size: 24px;
  margin-bottom: 24px;
  color: var(--text-primary);
  text-align: center;
}

.usage-steps {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
}

.usage-step {
  flex: 1;
  min-width: 250px;
  max-width: 300px;
  text-align: center;
}

.step-number {
  width: 48px;
  height: 48px;
  background: var(--accent-color);
  color: white;
  border-radius: 50%;
  font-size: 24px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}

.step-content h3 {
  font-size: 18px;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.step-content p {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.6;
}

/* 常见问题 */
.faq-section {
  margin-bottom: 48px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 32px;
  box-shadow: var(--shadow-sm);
}

.faq-section h2 {
  font-size: 24px;
  margin-bottom: 24px;
  color: var(--text-primary);
}

.faq-list {
  display: grid;
  gap: 20px;
}

.faq-item {
  padding: 20px;
  background: var(--bg-tertiary);
  border-radius: 12px;
}

.faq-item h3 {
  font-size: 16px;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.faq-item p {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.7;
  margin: 0;
}

@media (max-width: 768px) {
  .hero h1 {
    font-size: 32px;
  }

  .hero p {
    font-size: 16px;
  }

  .tools-grid {
    grid-template-columns: 1fr;
  }

  .intro-section,
  .usage-section,
  .faq-section {
    padding: 24px;
  }

  .intro-features {
    justify-content: center;
  }

  .usage-steps {
    flex-direction: column;
    align-items: center;
  }

  .usage-step {
    max-width: 100%;
  }
}
</style>
